/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * INTEREST: open the home for the resident to raise a hand. OFFER: send the terms straight away.
 * @export
 */
export const HomeownershipSaleMode = {
    Interest: 'interest',
    Offer: 'offer'
} as const;
export type HomeownershipSaleMode = typeof HomeownershipSaleMode[keyof typeof HomeownershipSaleMode];


export function HomeownershipSaleModeFromJSON(json: any): HomeownershipSaleMode {
    return HomeownershipSaleModeFromJSONTyped(json, false);
}

export function HomeownershipSaleModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipSaleMode {
    return json as HomeownershipSaleMode;
}

export function HomeownershipSaleModeToJSON(value?: HomeownershipSaleMode | null): any {
    return value as any;
}

